export default __webpack_public_path__ + "static/media/contact-us-classic-bg-1.65ff7897.jpg";